import { useQuery } from "@tanstack/react-query";
import { useLibrary } from "byzantine/src/dbbl/providers/useLibrary.hook";

export type RoutingType = "ach" | "fedwire";

/**
 * Resolves the financial institution name for a routing number via
 * `GET institutions/<routing_number>/<type>`. The request only fires for a
 * complete 9 digit routing number, and results are cached by react-query so
 * repeated renders (and other callers using the same number) share one lookup.
 */
export default function useInstitutionName(
  routingNumber: string | number | null | undefined,
  routingType: RoutingType
) {
  const { fetchApi, token } = useLibrary("network");

  const { data: institutionName, error } = useQuery({
    queryKey: [
      "institutions/routing_number/type",
      routingNumber,
      routingType,
      token,
    ],
    queryFn: () =>
      fetchApi(`institutions/${routingNumber}/${routingType}`)
        .then((response: { json: () => Promise<any> }) => response.json())
        .then((responseJson) => responseJson?.institution?.name),
    retry: false,
    enabled:
      !!token && !!routingNumber && routingNumber.toString().length === 9,
  });

  return { institutionName: institutionName as string | undefined, error };
}
